import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    '& > *': {
      margin: theme.spacing(2)
    },
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    width: '100vw',
    overflow: 'auto',
  },
  dfb: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(4)
  },
  dfe: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: 0
  },
  errMsg: {
    width: '15rem',
    color: 'red'
  },
  successMsg: {
    width: '15rem',
    color: 'green'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    width: '75%'
  },
  ml2: {
    marginLeft: theme.spacing(2),
  },
  mt2: {
    marginTop: theme.spacing(2),
  },
  fileUpload: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#e3e8ea',
    height: '30vh',
    border: '2px dashed gray',
    cursor: 'pointer'
  },
  lt: {
    fontSize: '2rem'
  },
  verticalBtn: {
    margin: 'auto',
    marginBottom: theme.spacing(2),
    width: '14rem'
  },
  plainBtn: {
    backgroundColor: '#E0E0E0',
    color: '#000000',
    '&:hover': { backgroundColor: '#D5D5D5' }
  },
  table: {
    minWidth: 650,
    cursor: 'pointer'
  },
  highlight: {
    backgroundColor: '#3B4B95',
    '& > *': { color: 'white' }
  },
  paper: {
    position: 'absolute',
    width: '32vw',
    minHeight: '48vh',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  dfr: {
    flexDirection: 'row'
  },
  redTxt: {
    color: 'red'
  },
  stickToBottom: {
    bottom: theme.spacing(2),
    position: 'absolute'
  },
  btnDanger: {
    backgroundColor: 'red',
    color: 'white'
  },
});
